import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'GET_DRIVER_UNITS_FORMATS': {
			var { response, payload } = action

			return {
				...state,
				inspection_formats: response,
			}
		}
		default:
			state = crudHandlers(state, action, 'inspection_format')

			return state
	}
}
